import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";

export default function New() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

    const [challenge, setchallenge] = useState([])
    
    // --- RESTORED ORIGINAL LOGIC: LIMIT & PAGINATION ---
    let [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [numberOfPages, setNumberOfPages] = useState(0);

    const setpageLimit = (event) => {
        let key = event.target.value
        setLimit(key);
        setPageNumber(1); // Limit change hone par page 1 par reset
    }

    const handlePageClick = (data) => {
        let currentPage = data.selected + 1;
        setPageNumber(currentPage);
    };

    const Allchallenge = async () => {
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        // Pagination aur Limit parameters ko API mein pass kiya gaya hai
        axios.get(baseUrl + `challange/new_challange?page=${pageNumber}&_limit=${limit}`, { headers })
            .then((res) => {
                setchallenge(res.data.status || res.data); // Support both structures
                setNumberOfPages(res.data.totalPages || 0);
            })
            .catch(err => console.log(err))
    }

    const dateFormat = (e) => {
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    }

    useEffect(() => {
        Allchallenge()
    }, [pageNumber, limit])

    if (challenge === undefined) {
        return null
    }

    // --- STYLES FOR DATA VISIBILITY & RESPONSIVE ---
    const containerStyle = { background: '#f0f2f5', minHeight: '100vh', padding: '15px', fontFamily: 'Poppins, sans-serif' };
    const headerCardStyle = { background: '#fff', padding: '20px', borderRadius: '15px', marginBottom: '20px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' };
    const tableCardStyle = { background: '#fff', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' };
    const thStyle = { background: '#f8f9fa', color: '#333', padding: '15px', fontWeight: '800', textAlign: 'center', borderBottom: '2px solid #ddd', whiteSpace: 'nowrap' };
    const tdStyle = { color: '#000000', fontWeight: '700', padding: '15px', textAlign: 'center', borderBottom: '1px solid #eee', background: '#fff', verticalAlign: 'middle' };

    return (
        <div style={containerStyle}>
            {/* Header Card with Restore Limit Selection */}
            <div style={headerCardStyle}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                    <div>
                        <h4 style={{ margin: 0, color: '#000', fontWeight: '900' }}>⭐ NEW CHALLANGES</h4>
                        <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '0.85rem' }}>Fresh battle requests waiting to be accepted</p>
                    </div>
                    {/* RESTORED: PAGE LIMIT SELECTOR */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#333' }}>Show:</span>
                        <select 
                            style={{ padding: '8px', borderRadius: '8px', border: '1px solid #ddd', fontWeight: 'bold', cursor: 'pointer' }} 
                            onChange={setpageLimit}
                            value={limit}
                        >
                            <option value="10">10 Rows</option>
                            <option value="20">20 Rows</option>
                            <option value="50">50 Rows</option>
                            <option value="100">100 Rows</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* Table Container */}
            <div style={tableCardStyle}>
                <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '900px' }}>
                        <thead>
                            <tr>
                                <th style={thStyle}>#</th>
                                <th style={thStyle}>Challenge ID</th>
                                <th style={thStyle}>Creator Name</th>
                                <th style={thStyle}>Amount</th>
                                <th style={thStyle}>Status</th>
                                <th style={thStyle}>Game Type</th>
                                <th style={thStyle}>Date Created</th>
                                <th style={thStyle}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {challenge.length > 0 ? (
                                challenge.map((game, index) => (
                                    <tr key={index}>
                                        <td style={tdStyle}>{(pageNumber - 1) * limit + (index + 1)}</td>
                                        <td style={{ ...tdStyle, color: '#007bff', fontSize: '12px', fontFamily: 'monospace' }}>{game._id}</td>
                                        <td style={tdStyle}>{game.Created_by?.Name || '---'}</td>
                                        <td style={{ ...tdStyle, color: '#28a745', fontSize: '1.1rem' }}>₹{game.Game_Ammount}</td>
                                        <td style={tdStyle}>
                                            <span style={{ background: '#fff3e0', color: '#e65100', padding: '4px 12px', borderRadius: '5px', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase' }}>
                                                {game.Status}
                                            </span>
                                        </td>
                                        <td style={{ ...tdStyle, textTransform: 'capitalize' }}>{game.Game_type}</td>
                                        <td style={{ ...tdStyle, fontSize: '11px', color: '#666' }}>{dateFormat(game.createdAt)}</td>
                                        <td style={tdStyle}>
                                            <Link 
                                                to={`/view/${game._id}`} 
                                                style={{ background: '#57155a', color: '#fff', padding: '8px 16px', borderRadius: '8px', textDecoration: 'none', fontSize: '13px', fontWeight: 'bold', display: 'inline-block' }}
                                            >
                                                VIEW
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ ...tdStyle, padding: '100px', color: '#999' }}>No new challenges found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* RESTORED: PAGINATION UI */}
            {numberOfPages > 0 && (
                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
                    <style>{`
                        .pagination { display: flex; list-style: none; gap: 5px; padding: 0; }
                        .page-item { border: 1px solid #ddd; border-radius: 8px; background: #fff; }
                        .page-link { padding: 10px 15px; color: #57155a; cursor: pointer; display: block; font-weight: bold; text-decoration: none; }
                        .active { background: #57155a !important; border-color: #57155a !important; }
                        .active a { color: #fff !important; }
                    `}</style>
                    <ReactPaginate
                        previousLabel={"← Prev"}
                        nextLabel={"Next →"}
                        breakLabel={"..."}
                        pageCount={numberOfPages}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        activeClassName={"active"}
                        forcePage={pageNumber - 1}
                    />
                </div>
            )}
        </div>
    )
}